export default "__VITE_ASSET__Cbqeu3TX__"